import { api, authHeader, getLocalRefreshToken } from "../configs/axiosConfigs";
import { persistAuthUser } from "../utils/authSession";

const requestVerifyCode = async (mobileNumber) => {
  const response = await api.request({
    url: `account/VerifyRequest`,
    method: "POST",
    data: { mobileNumber },
  });
  return response.data;
};

const checkVerifyCode = async ({ mobileNumber, verifyCode, forSignup = false }) => {
  const response = await api.request({
    url: `account/CheckVerifyCode`,
    method: "POST",
    data: {
      mobileNumber,
      verifyCode,
      forSignup: Boolean(forSignup),
    },
  });

  const payload = response?.data;
  const isSuccess = payload?.isSuccess ?? payload?.IsSuccess;
  if (!isSuccess) {
    throw payload || { message: "کد تأیید نامعتبر است." };
  }

  // Signup may succeed with null data (OTP valid, account not created yet).
  const authData = payload?.data ?? payload?.Data ?? null;
  // During signup, never auto-login an existing account (avoids broken half-registered sessions).
  if (authData && !forSignup) {
    persistAuthUser(authData);
  }

  return payload;
};

const register = async (userData) => {
  const response = await api.request({
    url: `account/signup`,
    method: "POST",
    data: userData,
  });

  if (response.data.isSuccess) {
    persistAuthUser(response.data.data);
  }

  return response.data;
};

const login = async (username, password) => {
  const response = await api.request({
    url: `account/login`,
    method: "POST",
    data: {
      username,
      password,
    },
  });

  if (response.data.isSuccess) {
    persistAuthUser(response.data.data);
  }

  return response.data;
};

const getLoginKind = async () => {
  const response = await api.request({
    url: `Account/LoginKind`,
    method: "GET",
  });
  return response.data;
};

const refreshToken = async () => {
  const refresh = getLocalRefreshToken();
  if (!refresh) {
    throw new Error("Refresh token missing");
  }

  const response = await api.request({
    url: `account/RefreshToken`,
    method: "POST",
    headers: authHeader(),
    data: {
      RefreshToken: refresh,
    },
  });

  if (response.data.isSuccess && response.data.data) {
    persistAuthUser(response.data.data);
    return response.data;
  }

  throw new Error("Refresh token failed");
};

const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("defaultUrl");
  localStorage.removeItem("isShowMainMenu");
  localStorage.removeItem("currentUserId");
  localStorage.removeItem("system-config");
};

const AuthService = {
  register,
  login,
  logout,
  refreshToken,
  getLoginKind,
  checkVerifyCode,
  requestVerifyCode,
};

export default AuthService;
